import { render, staticRenderFns } from "./UsersSearch.vue?vue&type=template&id=428d640c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./UsersSearch.vue?vue&type=script&lang=js&"
export * from "./UsersSearch.vue?vue&type=script&lang=js&"
import style0 from "./UsersSearch.vue?vue&type=style&index=0&id=428d640c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d640c",
  null
  
)

export default component.exports